import { Injectable } from '@angular/core';
import { Messaging, getToken, onMessage } from '@angular/fire/messaging';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class FireBaseMessagingService {
  currentMessage = new BehaviorSubject<any>(null);

  constructor(
    private messaging: Messaging,
    private auth: AuthService
  ) {}

  updateToken(token: string) {
    const obj = { web_token: token };
    if (localStorage.getItem('usertype') === 'User') {
      this.updateUserFCMToken(obj);
    } else {
      this.updateOtherFCMToken(obj);
    }
  }

  requestPermission() {
    getToken(this.messaging).then((token) => {
      if (token && localStorage.getItem('token')) {
        this.updateToken(token);
      }
    }).catch((err) => {
      console.warn('FCM token error:', err);
    });
  }

  receiveMessage() {
    onMessage(this.messaging, (payload) => {
      if (payload && payload['data']) {
        this.auth.setNotification(payload['data']);
        this.currentMessage.next(payload);
      }
    });
  }

  updateUserFCMToken(obj: any) {
    this.auth.updateUserFCMToken(obj).subscribe(() => {});
  }

  updateOtherFCMToken(obj: any) {
    this.auth.updateOtherFCMToken(localStorage.getItem('usertype'), obj).subscribe(() => {});
  }
}
